import { render, staticRenderFns } from "./chonburi.vue?vue&type=template&id=2c5c518d&scoped=true"
import script from "./chonburi.vue?vue&type=script&lang=js"
export * from "./chonburi.vue?vue&type=script&lang=js"
import style0 from "./chonburi.vue?vue&type=style&index=0&id=2c5c518d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5c518d",
  null
  
)

export default component.exports